import { actions as detailPickerActions } from "reducers/detailPicker";
import { actions as pickerActions } from "reducers/pickers";
import { actions as preliActions } from "reducers/preliquidation";
import { actions as regionsActions } from "reducers/regions";
import { actions as slotsActions } from "reducers/slots";
import { actions as dashboardActions } from "reducers/dashboard";
import { actions as slotTemplateActions } from "reducers/slotTemplates";
import { store } from "store";

const resetData = () => {
  const { dispatch } = store;
  dispatch(detailPickerActions.resetAccountType());
  dispatch(detailPickerActions.resetBanks());
  dispatch(detailPickerActions.resetProvinces());
  dispatch(pickerActions.resetIdentificationTypes());
  dispatch(preliActions.resetInvoiceDetailTypes());
  dispatch(regionsActions.resetRegions());
  dispatch(regionsActions.resetOrigins());
  dispatch(slotsActions.resetStatus());
  dispatch(dashboardActions.resetFilter());
  dispatch(regionsActions.resetFilter());
  dispatch(preliActions.resetFilters());
  dispatch(slotsActions.resetFilter());
  dispatch(slotTemplateActions.resetFilter());
  dispatch(slotsActions.setActualPage("slots"));
  dispatch(pickerActions.setActualPage("pending"));
  dispatch(pickerActions.resetFilters());
  dispatch(regionsActions.resetPricing());
  dispatch(regionsActions.resetNextRain());
};

export default resetData;
